/**
 * EM FLOSS — Homepage anchor scroll nav
 * Rewrites .nav-link and .mobile-link clicks to smooth-scroll to sections.
 * Only active on the homepage (pathname === '/').
 */
(function () {
  if (window.location.pathname !== '/') return;

  // Map: link label text (lowercase, trimmed) → CSS selector to scroll to
  var NAV_MAP = {
    'home':       null,                                                     // scroll to very top
    'shop':       '#shopify-section-best_sellers_grid',                     // Best Sellers section
    'faqs':       '#shopify-section-faq_em_fVQAMU',                        // FAQ section
    'about us':   '#shopify-section-about_em_section, #about-us',           // About Us section
    'contact us': '.footer, #shopify-section-footer, footer'               // Footer
  };

  function smoothScrollTo(selector) {
    if (!selector) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    var selectors = selector.split(',');
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i].trim());
      if (el) {
        var offset = 80; // account for sticky header height
        var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
        return;
      }
    }
  }

  function closeMobileMenu() {
    var menu = document.getElementById('mobileMenu');
    var overlay = document.querySelector('.mobile-overlay');
    if (menu) menu.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  function patchLinks() {
    // Target both desktop (.nav-link) and mobile (.mobile-link) nav links
    var links = document.querySelectorAll('.nav-link, .mobile-link');
    links.forEach(function (link) {
      // Get visible text only (strip badge text like "New", "Hot")
      var text = '';
      link.childNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) text += node.textContent;
      });
      text = text.trim().toLowerCase();

      if (text in NAV_MAP) {
        link.addEventListener('click', function (e) {
          if (window.location.pathname !== '/') return;
          e.preventDefault();
          closeMobileMenu();
          // Small delay if mobile menu was open so it animates out first
          setTimeout(function () {
            smoothScrollTo(NAV_MAP[text]);
          }, 50);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchLinks);
  } else {
    patchLinks();
  }
})();
